/*
  Store Builder craft: Horizon's cart drawer opens at the Add to Cart press, with the line drawn from the page (21 Oct
  2026; store-kit/README.md, "The cart at the press"). The user, 21 Oct 2026: "when I first click ATC it takes maybe
  2-3 seconds for product to appear". Measured on Lily Ashwood and Emma Skinner, Horizon's drawer stayed shut on an
  empty cart until Shopify's add and a second cart read had both landed (0.6 to 1.3 s), then the line's photo loaded
  cold. Now, on Horizon's add event from the product page's own form (never a quick-add dialog), the line is drawn
  at once: the photo at the address snippets/sb-cart-photo-preload.liquid fetched with the page, the title, the
  colour / size picked and the price on the page. The empty cart's block steps aside and the drawer's "Cart" heading
  shows while it is up (store-builder.css), and a shut drawer opens. Horizon's own update then morphs Shopify's line
  in, which takes the drawn one away (its own tag, so the morph never reuses it); an error or a failed add takes it
  away and shuts the drawer this script opened. Nothing without cart-drawer-component[auto-open]: a cart app
  (UpCart) has the add. Deferred after store-builder-craft-size.js. No network, no markup from strings.
*/
(() => {
if (window.sbCart) return;
window.sbCart = true;

const doc = document;
// Horizon's morph has nearly always landed by then; whatever is left of the drawn line goes.
const LEFT_UP_MS = 1500;
const LINE = 'sb-cart-line';
const HEADING = 'sb-cart-heading';

const el = (tag, cls, text) => {
  const made = doc.createElement(tag);
  if (cls) made.className = cls;
  if (text) made.textContent = text;
  return made;
};
const fileOf = (url) => (url || '').split('?')[0].split('/').pop();

// The fetched photo of the variant Horizon has chosen (add-to-cart-component keeps its photo), else that photo at 250.
function photoOf(form, box) {
  const media = form.querySelector('add-to-cart-component')?.dataset.productVariantMedia || '';
  const fetched = [...box.querySelectorAll('img')].map((img) => img.getAttribute('src') || '');
  return (media && fetched.find((src) => fileOf(src) === fileOf(media))) || media.replace(/([?&])width=\d+/, '$1width=250');
}

function lineFor(form, section, box) {
  const picked = [...section.querySelectorAll('variant-picker input[type="radio"]:checked, variant-picker select')]
    .map((input) => input.value).filter(Boolean);
  const price = (section.querySelector('product-price .price')?.textContent || '').replace(/\s+/g, ' ').trim();
  const row = el(LINE);
  row.setAttribute('aria-hidden', 'true');
  const photo = el('img', 'sb-cart-line__photo');
  photo.alt = '';
  const src = photoOf(form, box);
  if (src) photo.setAttribute('src', src);
  const words = el('div');
  words.append(el('p', 'sb-cart-line__title', box.dataset.sbTitle), el('p', 'sb-cart-line__meta', picked.join(' / ')),
    el('p', 'sb-cart-line__meta', price));
  row.append(photo, words);
  return row;
}

doc.addEventListener('shopify:cart:lines-update', (event) => {
  if (event.action !== 'add') return;
  const form = event.target instanceof Element ? event.target.closest('product-form-component') : null;
  // The page's own buy buttons carry the preload box (blocks/buy-buttons.liquid, sb_own); a quick-add sits in a dialog.
  const box = form?.parentElement?.querySelector('.sb-cart-preload');
  if (!box || !form.closest('main') || form.closest('dialog')) return;
  const drawer = doc.querySelector('cart-drawer-component[auto-open]');
  const shell = drawer?.closest('theme-drawer');
  const items = drawer?.querySelector('.cart-drawer__inner .cart-drawer__items');
  if (!items || typeof shell?.open !== 'function') return;
  const row = lineFor(form, form.closest('.shopify-section') || doc, box);
  items.prepend(row);
  const header = drawer.querySelector('.cart-drawer--empty > .theme-drawer__header');
  if (header && box.dataset.sbHeading && !header.querySelector(HEADING)) {
    header.prepend(el(HEADING, 'theme-drawer__title h4', box.dataset.sbHeading));
  }
  drawer.setAttribute('data-sb-adding', '');
  const opened = !shell.isOpen;
  if (opened) shell.open();
  const done = (failed) => {
    row.remove();
    if (!drawer.querySelector(LINE)) {
      drawer.removeAttribute('data-sb-adding');
      for (const heading of drawer.querySelectorAll(HEADING)) heading.remove();
    }
    if (failed && opened && shell.isOpen) shell.close();
  };
  Promise.resolve(event.promise).then((answer) => {
    if (answer?.detail?.didError) done(true);
    else setTimeout(() => done(false), LEFT_UP_MS);
  }, () => done(true));
});
})();
